import styled from 'styled-components';

export const AttributeWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    margin-bottom: 30px;
    word-break: break-all;

    & div {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

export const IconWrapper = styled.div`
    min-width: 20px;
    margin-left: 80px;
`;
